import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function CompassBlue({...props}) {
    const {
      className,
      imageUrl,
      children,
      style
    } = props;
    const data = useStaticQuery(
      graphql`
        query {
          desktop: file(relativePath: { eq: "compass-blue.jpg" }) {
            childImageSharp {
              fluid(quality: 80, maxWidth: 1280) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `
    );

    // Set ImageData.
    const imageData = data.desktop.childImageSharp.fluid;

    return (
      <BackgroundImage 
      Tag="section"
      role="img"
      aria-label="A compass held in gloved hand up against the backdrop of a fjord."
      className={className}
      fluid={imageData}
      style={style}
    >
      {children}
    </BackgroundImage>
    )
  }

const styles = {
  width: "100%",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
}

export default withStyles(styles)(CompassBlue)